import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components/macro';

interface FeeRowContainerProps {
  isTotal?: boolean;
  isSummary?: boolean;
  isTitleContainer?: boolean;
}

interface Props extends FeeRowContainerProps {
  feeName: string | ReactNode;
  feeNameSubItems?: string[];
  quantity?: number | ReactNode;
  value: string | ReactNode;
}

const Container = styled.div<FeeRowContainerProps>`
  padding: 1rem;
  box-shadow: 0px -1px 0px 0px #dee3e5 inset;
  min-height: 56px;
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.isTotal
      ? css`
          background: #dee3e5;
          padding: 1rem;
          box-shadow: 0px -1px 0px 0px #dee3e5 inset;
          font-weight: 700;
        `
      : ''}
  ${(props) =>
    props.isTitleContainer
      ? css`
          background: #dee3e5;
          padding: 1rem;
          font-weight: 700;
        `
      : ''}
  ${(props) =>
    props.isSummary
      ? css`
          background: #f4f7f9;
          padding: 1rem;
          font-weight: 700;
        `
      : ''}
`;

const RowContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

const RowDescription = styled.div`
  flex: 1;
`;

const RowQuantity = styled.div`
  min-width: 130px;
  text-align: center;
`;

const RowValue = styled.div`
  min-width: 130px;
  text-align: end;
`;

const formatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});

export const FeeRow = ({ feeName, feeNameSubItems, value, quantity, ...containerProps }: Props) => (
  <Container {...containerProps}>
    <RowContainer>
      <RowDescription>
        {feeName}
        {feeNameSubItems?.length > 0 && (
          <ul>
            {feeNameSubItems.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        )}
      </RowDescription>
      {quantity != null && <RowQuantity>{quantity}</RowQuantity>}
      <RowValue>{typeof value === 'number' ? formatter.format(value) : value}</RowValue>
    </RowContainer>
  </Container>
);
